const Cartera = () =>
  import("@/views/cartera/Cartera");

const CarteraEstadoCuentaTotal = () =>
  import("@/views/cartera/EstadoCuentaTotal");



export const CarteraEstadoCuentaTotalRoute = {
  path: "estadoCuentaTotal",
  component: CarteraEstadoCuentaTotal,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",
    backState: "/cartera/estadoCuentaTotal",
    breadcrumb: [
      {
        text: "Cartera",
        disabled: true,
        href: "#"
      },
      {
        text: "Estado Cuenta Total",
        disabled: false,
        href: "#"
      }
    ],
      scope:["aps_broker","aps_executive"],
  }
};



export const CarteraRoute = {
  path: "cartera",
  component: Cartera,
  redirect: '/cartera/estadoCuentaTotal',
  children: [
    CarteraEstadoCuentaTotalRoute    
  ]
}